<template>
  <user-center-wrap>
    <div class="recharge-history">
      <div class="search_condition">
        <div class="title">充值记录</div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-date-picker
              v-model="formInline.time"
              class="dataTimer"
              type="daterange"
              size="mini"
              range-separator="~"
              prefix-icon="el-icon-date"
              popper-class="dateTimer-droper"
              value-format="yyyy-MM-dd"
              format="yyyy/MM/dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        border
        :data="tableData"
        :row-style="{ height: '0.72rem', fontSize: '0.14rem' }"
        :cell-style="{ padding: 0 }"
        :header-row-style="tableHeaderRow"
        :header-cell-style="tableHeaderColor"
        height="100%"
        style="width: 100%"
        v-if="tableData.length > 0"
        v-loading="loading"
      >
        <el-table-column prop="order_no" label="订单号" align="center" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="width: 1.7rem; cursor: pointer" class="share-copy" :data-clipboard-text="scope.row.order_no" @click="copy()">{{
              scope.row.order_no
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_channel" label="付款方式" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="create_time" label="充值时间" align="center">
          <template slot-scope="scope">
            <div class="create_time_top">{{ moment(scope.row.create_time).format("YYYY-MM-DD ") }}</div>
            <div class="create_time_top">{{ moment(scope.row.create_time).format("HH:mm:ss") }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="gold" label="购买克拉数" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.gold / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gold_added" label="赠送克拉数" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.gold_added / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_amount" label="订单金额" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.pay_amount / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" label="订单状态" align="center" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="color: #ffba39" v-if="scope.row.raw_pay_status == 0">{{ scope.row.pay_status }}</span>
            <span style="color: #02a8a2" v-if="scope.row.raw_pay_status == 1">{{ scope.row.pay_status }}</span>
            <span style="color: #999999" v-if="scope.row.raw_pay_status == 2">{{ scope.row.pay_status }}</span>
            <span style="color: #999999" v-if="scope.row.raw_pay_status == 3">{{ scope.row.pay_status }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="empty" v-if="tableData.length === 0 && !loading" class="search_list">
        <div class="list_body">
          <div class="empty_content">
            <Empty text="暂无数据" :imgWidth="250" :img="require('@/assets/img/empty/no-data.png')"></Empty>
          </div>
        </div>
      </div>

      <div class="pagination_bottom" v-if="tableData.length > 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="info.size"
          :total="totalCount"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="info.page"
        ></el-pagination>
      </div>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "@/components/user-center-wrap/user-center-wrap";
import { post } from "@/util/http";
import moment from "moment";
import Empty from "@/components/empty/empty";
import { mapState, mapMutations } from "vuex";
import Cipboard from "clipboard";
export default {
  components: {
    Empty,
    UserCenterWrap,
  },
  data() {
    return {
      moment: moment,
      spend_type_list: [
        { label: "活动", value: 3 },
        { label: "鹰选彩金", value: 2 },
        { label: "礼物", value: 1 },
        { label: "全部", value: 0 },
      ],
      formInline: {
        spend_type: "",
        order_no: "",
        time: [],
      },
      tableData: [],
      info: {
        page: 1,
        size: 10,
      },
      totalCount: 0,

      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (maxDate && minDate) {
            this.$nextTick(() => {
              this.getListInfo();
            });
          }
        },
      },
      loading: true,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  props: {},

  mounted() {
    this.formInline.time = this.getNowTime(30, 0);
    this.getListInfo();
  },
  methods: {
    copy() {
      var copyBtn = new Cipboard(".share-copy");
      copyBtn.on("success", (e) => {
        this.$message.success("复制成功");
        copyBtn.destroy();
      });
    },
    getNowTime(day, days) {
      const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * day).toISOString().replace("T", " ").split(" ")[0];
      const end = new Date(new Date().getTime() - 3600 * 1000 * 24 * days).toISOString().replace("T", " ").split(" ")[0] + " 23:59:59";
      return [start, end];
    },
    handleSizeChange(val) {
      this.$set(this.info, "size", val);
      // console.log(`每页 ${val} 条`);
      this.selectList();
    },
    handleCurrentChange(val) {
      this.$set(this.info, "page", val);
      //console.log(`当前页: ${val}`);
      this.getListInfo();
    },
    getListInfo() {
      this.loading = true;
      console.log(this.formInline.time, "this.formInline.time");
      let data = {
        user_id: this.userInfo.id,
        page: this.info.page,
        size: this.info.size,
        start_date: this.formInline.time[0],
        end_date: this.formInline.time[1],
      };

      post({
        url: "/api/payment/getPaymentList",
        data,
      }).then(({ data: { data } }) => {
        this.tableData = data.list || [];
        this.totalCount = data.total;
        this.loading = false;
      });
    },
    // 设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // return 'background-color: #c7e7e2;color:#526e6e;font-size: 14px;font-weight:600; height: 36px;padding: 0px'
      return `
				background-color:#02A8A2;
				color:#ffffff;
				font-size: 14px;
				font-weight:500;
				height: 36px;
				padding: 0px";
				border : 0px;
			 `;
    },
    tableHeaderRow() {
      //return 'height: 36px'
      return `
				height:56px;
				letter-spacing:1px;
				border-radius : 20px;
			`;
    },
  },
};
</script>
<style lang="scss" scoped>
.recharge-history {
  padding: 0.28rem 0.44rem;
}
.search_condition {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.2rem;
  .title {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 500;
    font-size: 0.2rem;
    line-height: 0.5rem;
    color: #333333;
  }
}

.create_time_top {
  line-height: 1;
}
::v-deep.el-form-item__label {
  color: #333;
}

.demo-form-inline {
  padding: 0px 5px;
  justify-content: space-between !important;

  .dataTimer {
    width: 2.2rem;
  }
}

.search_list {
  width: 100%;

  .list_body {
    height: 4.44rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .empty_content {
      img {
        width: 136px;
        height: 156px;
        margin-bottom: 39px;
      }

      .empty_text {
        font-size: 14px;
        color: #999;
        text-align: center;
      }
    }
  }
}

.el-form-item {
  margin: 0;
}

.el-table {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.el-tabs__item {
  font-size: 18px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 400;
  padding: 0;
  margin-right: 40px;
}
.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #02a8a2;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 4px;
    background: #02a8a2;
    border-radius: 100px;
  }
}
.el-tabs__active-bar {
  height: 0px;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}

.popper__arrow {
  display: none;
}
.el-popper {
  left: 0px;
  border: 0px !important;
  // top: 24px !important;
  margin-top: 6px !important;
}
.el-icon-arrow-up:before {
  color: #000000;
  transform: rotate(180deg);
  display: block;
}
.el-icon-date {
  right: 19px;
  top: 5px;
  position: absolute;
  &:before {
    content: "";
    // background-image: url(../../assets/img/child/share_rili.png);
    background-size: 100% auto;
    display: block;
    width: 24px;
    height: 24px;
  }
}
.el-range__close-icon {
  z-index: 20000;
  display: block;
  right: 0px;
  top: 2px;
  position: absolute;
}

.el-form-item__label {
  line-height: 38px;
}
.el-input--suffix .el-input__inner {
  background: #f7f7f7;
}
.el-input__inner {
  border-color: #f0f0f0 !important;
  //color : #333333 !important;
  &:hover {
    border-color: #f0f0f0 !important;
  }
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #f0f0f0;
}
.el-select .el-input__inner:focus {
  border-color: #f0f0f0;
}
.el-range-input {
  background: #f7f7f7 !important;
  //color: #333333 !important;
}
.el-date-editor {
  border-color: #f0f0f0 !important;
  background: #f7f7f7 !important;
}
.el-input__inner {
  background: #f7f7f7 !important;
  border-color: #f0f0f0;
  //color : #333333;
}
.el-input__inner:focus {
  border-color: #f0f0f0;
}
.el-select-dropdown__item {
  text-align: center;
}
.el-select-dropdown__item.selected,
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: rgba(38, 217, 157, 0.1);
  color: #333333;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #02a8a2;
}

.pagination_bottom {
  padding: 10px;
  display: flex;
  justify-content: center;
}
</style>
